import { AgentStatus } from '@21k/shared';

import { normalizeAgentStatus, STATUS_CONFIG } from '../utils/agentStatus';

type Props = {
  value: string | null | undefined;
  onChange: (status: AgentStatus) => void;
  disabled?: boolean;
  className?: string;
};

const OPTIONS: AgentStatus[] = [
  AgentStatus.LIVE,
  AgentStatus.AWAY,
  AgentStatus.ON_LEAVE,
  AgentStatus.OFFLINE,
];

export default function AgentStatusSelect({
  value,
  onChange,
  disabled,
  className = 'agent-status-admin-select',
}: Props) {
  const normalized = normalizeAgentStatus(value);

  return (
    <select
      className={className}
      value={normalized}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value as AgentStatus)}
      aria-label="Change agent availability"
    >
      {OPTIONS.map((status) => (
        <option key={status} value={status}>
          {STATUS_CONFIG[status].label}
        </option>
      ))}
    </select>
  );
}
